import { axios, API, SendRequest} from '@/imports-files/pages/admins/logout';

export class Logout extends SendRequest {
  async signOutUser() {
    try {
      const result = await axios.delete( API.admins.LOGOUT_URL,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }
}